import { DEFAULT_LANG } from './config';

// 明朝／セリフ体の言語別スタック。
// Webフォントは読み込まない。CJKのWebフォントはサブセット配信でも数百KB規模に
// なるため、OS標準フォントで賄う（主要OSはいずれも簡体字・繁体字を標準搭載）。
const SERIF_STACKS = {
  ja: "'Yu Mincho', 'YuMincho', 'Hiragino Mincho ProN', 'Noto Serif JP', serif",
  en: "Georgia, 'Times New Roman', serif",
  'zh-CN': "'Songti SC', 'STSong', SimSun, 'Noto Serif SC', serif",
  'zh-TW': "'Songti TC', PMingLiU, 'Noto Serif TC', serif",
};

export const serifFont = (lang) => SERIF_STACKS[lang] || SERIF_STACKS[DEFAULT_LANG];

export default serifFont;
